import React, { useState } from "react";
import { Grid } from "@material-ui/core";
import { Assort } from "../../../models/Assort";
import AssortLine from "./AssortLine";
import { useTranslation } from "react-i18next";
interface IProps {
  assorts: Assort[];
  onAddLine: (assort: Assort, qnt: number) => void;
}

const AnotherSteps: React.FC<IProps> = ({ assorts, onAddLine }: IProps) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} style={{ marginBottom: "10px" }}>
        <div className="alert alert-yellow alert-big alert-thin" style={{ marginBottom: "16px" }}>
          {t("wybierz_bilet_dla_swojej_grupy")} {t("wybierz_odpowiednia_ilosc_oraz_typ_biletow")}
        </div>
      </Grid>

      {assorts.map((item: Assort, index: number) => (
        <Grid style={{ marginBottom: "10px" }} key={index} item xs={12} className="ticket-line flex-between-center">
          <AssortLine item={item} onAddLine={onAddLine} />
        </Grid>
      ))}
    </Grid>
  );
};

export default AnotherSteps;
